import React from "react";
// import MyLottie from "../elements/MyLottie";
import { outerLink } from "../../utils/functions";
import VideoBox from "./VideoBox";

const Landing = () => {
  // const [AnimationDataWeb, setAnimationDataWeb] = useState(null);

  // useEffect(() => {
  //   const myScreenSize = window.innerWidth;

  //   if (myScreenSize > 640) {
  //     import("../../assets/lotties/datazip-website-animation.lottie").then(
  //       (value) => {
  //         setAnimationDataWeb(value.default);
  //       }
  //     );
  //   } else {
  //     import("../../assets/lotties/datazip-mobile-animation.lottie").then(
  //       (value) => {
  //         setAnimationDataWeb(value.default);
  //       }
  //     );
  //   }
  // }, []);

  return (
    <>
      <div className="landing__box">
        <div className="container">
          <div className="landing__tag">
            <img
              src={require("../../assets/images/onestack-logo.svg")}
              alt="one stack logo"
            />
            <div className="landing__tag-text">
              One<span>Stack</span> Data
            </div>
          </div>
          <div className="landing__heading text__main reveal-from-top">
            Making Data Engineers <br />
            <span>10x More Productive</span>
          </div>

          <div className=" text__sub landing__sub reveal-from-bottom">
            Ingest, store, organize, and query all your data at one place while
            we take care of the infra scale, enable data quality and data
            access.
          </div>
          <div className="landing__cta">
            <button
              className="button__main button__primary reveal-from-left"
              data-reveal-delay="200"
              onClick={() =>
                outerLink(
                  "https://calendly.com/d/dx2-qrw-g8j/datazip-demo-call"
                )
              }
            >
              Talk to Sales
            </button>
            {/* <Link to={"/onestack-data/login"}>
              <button
                className="button__main button__secondary reveal-from-bottom"
                data-reveal-delay="200"
              >
                Access Sandbox - it's free
                <img
                  src={require("../../assets/images/long-arrow-right-black.svg")}
                  alt="arrow-right"
                />
              </button>
            </Link> */}
            <div className="g2 reveal-from-right">
              <div className="g2_box-content">
                <div className="g2_rating">4.7</div>
                <img
                  src={require("../../assets/images/5-Stars.svg")}
                  alt="stars"
                />
                <div
                  className="g2_link"
                  onClick={() =>
                    outerLink("https://www.g2.com/products/datazip/reviews")
                  }
                >
                  Read our reviews on
                </div>
              </div>
              <div className="g2_img-box">
                <img
                  src={require("../../assets/images/g2_logo.svg")}
                  alt="g2 logo"
                />
              </div>
            </div>
          </div>
          <div
            className="landing__hosted reveal-from-left"
            data-reveal-delay="400"
            data-reveal-offset="0"
          >
            Hosted in your own cloud on
          </div>
          <div
            className="landing__images reveal-from-bottom"
            data-reveal-delay="400"
            data-reveal-offset="0"
          >
            <img src={require("../../assets/images/aws.svg")} alt="aws" />
            <img
              src={require("../../assets/images/google_cloud.svg")}
              alt="google_cloud"
            />
            <img src={require("../../assets/images/azure.svg")} alt="azure" />
          </div>
        </div>
      </div>
      <div className="video__box">
        <VideoBox
          videoSrc="https://www.youtube.com/embed/-0zx5U4mA2g"
          previewImage={require("../../assets/images/testing-new.webp")}
          playButtonImage={require("../../assets/images/play.svg")}
          outerClassName={"landing-page-video-outer"}
          playButtonAnimation={true}
          isHoverAnimation={true}
        />
        <div className="mask"></div>
        <div className="text__heading reveal-from-top">
          Data Infrastructure and Analytics on Autopilot
        </div>
        <div className="ta-c text__sub reveal-from-bottom">
          From raw data to consumption ready data in minutes, not months
        </div>
        <div className="video reveal-from-bottom">
          <img
            src={require("../../assets/images/datazip-landing-image.svg")}
            alt="landing details"
          />
          {/* {AnimationDataWeb && (
            <div className="web">
              <MyLottie src={AnimationDataWeb} width={"60vw"} height={"auto"} />
            </div>
          )}
          {AnimationDataWeb && (
            <div className="mobile">
              <MyLottie src={AnimationDataWeb} width={"90vw"} height={"auto"} />
            </div>
          )} */}
        </div>
      </div>
    </>
  );
};

export default Landing;
